"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StonehengeLogEvent = void 0;
const entity_1 = require("@jobilla/entity");
class StonehengeLogEvent extends entity_1.Entity {
    constructor() {
        super(...arguments);
        this.domain = null;
        this.actorId = null;
        this.eventId = null;
        this.emitterId = null;
        this.emitterType = null;
        this.origin = null;
        this.metadata = null;
    }
}
exports.StonehengeLogEvent = StonehengeLogEvent;
//# sourceMappingURL=LogEvent.entity.js.map